import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="5" height="16" {...props}><path fill="#fff" fillOpacity=".01" strokeWidth="3" stroke="#fff" d="M0 0h5v16H0z" /></svg>);